import baseAPI from "@/http";

const router = "api/territorios-categorias";

export const territoriosCategoriaAPI = {
  create: (city) => baseAPI.post(router, city),
  update: (city) => baseAPI.put(router, city),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listByFase: (territorioFaseId) =>
    baseAPI.get(
      `${router}/Obter-Territorio-categoria-por-fase?id=${territorioFaseId}`
    ),
};
